(ns rothko.theme.manatee.editor.component
  (:refer-clojure :exclude [rem])
  (:require [garden.units :refer [rem]]))

(def common
  {:border-top "2px solid black"
   :padding (rem 1)
   :box-shadow "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);"})

(def main
  {:est-transcription-annotator common
   :est-error-annotator common
   :script-annotator common
   :mwe-annotator common})
